"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * @author yuqzho@microsoft.com, Ning Tang
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageExtensionWithExistingApiSpecGenerator = void 0;
const m365_spec_parser_1 = require("@microsoft/m365-spec-parser");
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const error_1 = require("../../../error");
const question_1 = require("../../../question");
const defaultGenerator_1 = require("../defaultGenerator");
const templateNames_1 = require("../templates/templateNames");
const common_1 = require("./common");
const helper_1 = require("./helper");
class MessageExtensionWithExistingApiSpecGenerator extends defaultGenerator_1.DefaultTemplateGenerator {
    componentName = "me-with-existing-api-generator";
    activate(context, inputs) {
        return templateNames_1.TemplateNames.MessageExtensionWithExistingApiSpec == inputs[question_1.QuestionNames.TemplateName];
    }
    async getTemplateInfos(context, inputs, destinationPath, actionContext) {
        return (0, common_1.getTemplateInfosFromApiSpec)(context, inputs, m365_spec_parser_1.ProjectType.SME, actionContext);
    }
    async post(context, inputs, destinationPath, actionContext) {
        try {
            return await (0, common_1.generateFilesFromApiSpec)(context, inputs, destinationPath, m365_spec_parser_1.ProjectType.SME, this.componentName);
        }
        catch (e) {
            let error;
            if (e instanceof m365_spec_parser_1.SpecParserError) {
                error = (0, helper_1.convertSpecParserErrorToFxError)(e);
            }
            else {
                error = (0, error_1.assembleError)(e);
            }
            return (0, teamsfx_api_1.err)(error);
        }
    }
}
exports.MessageExtensionWithExistingApiSpecGenerator = MessageExtensionWithExistingApiSpecGenerator;
//# sourceMappingURL=messageExtensionGenerator.js.map